"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const avanthika_jpeg_1 = __importDefault(require("../../assets/avanthika.jpeg"));
const utils_1 = require("../../utils");
const react_router_dom_1 = require("react-router-dom");
const Footer = () => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const isHome = pathname === "/";
    return (react_1.default.createElement("div", { className: "fixed bottom-0 w-full" },
        react_1.default.createElement("p", { className: "p-4 border-t border-[rgb(220,220,220)] bg-[#FFFFFF] text-xs text-center" },
            "If you'd like to connect, feel free to send me an",
            " ",
            utils_1.socialLinks.email,
            " or reach out on ",
            utils_1.socialLinks.linkedin,
            ".",
            " ",
            isHome ? (react_1.default.createElement(react_1.default.Fragment, null,
                "You can also take a look at my ",
                utils_1.socialLinks.resume,
                " here.")) : (react_1.default.createElement(react_1.default.Fragment, null,
                "Or head back to the ",
                utils_1.socialLinks.home,
                "."))),
        react_1.default.createElement("footer", { className: "h-[65px] p-[10px] bg-[rgba(32,32,34,1)]" },
            react_1.default.createElement("div", { className: "flex items-center justify-between max-w-[60%] max-lg:max-w-full mx-auto" },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: "/" },
                    react_1.default.createElement("img", { src: avanthika_jpeg_1.default, alt: "Avanthika Meenakshi, Software Engineer", className: "w-12 h-12 rounded-full grayscale" })),
                react_1.default.createElement("div", null,
                    utils_1.socialLinks.github,
                    utils_1.socialLinks.linkedInIcon,
                    utils_1.socialLinks.twitterIcon,
                    utils_1.socialLinks.facebookIcon,
                    utils_1.socialLinks.mediumIcon,
                    utils_1.socialLinks.stackoverflowIcon)))));
};
exports.default = Footer;
